export interface IThrottle {
  timeoutId: number
  readonly timeoutMs: number
}
